var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { REACT_APP__RECAPTCHA_TOKEN, REACT_APP__URL_EASYPOST_BASE, } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./user.static";
export const ApiEpUsers = {
    Me: {
        /**
         * Used to get current user
         */
        retrieve: () => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/me`,
                method: "GET",
            }, failureHash)
                .then((resp) => {
                window.epUserId = resp.user.id;
                return resp;
            })
                .catch((e) => {
                window.epUserId = undefined;
                throw e;
            });
        }),
        /**
         * Used to update current user
         */
        updatePartial: (userPartial) => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                body: userPartial,
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/me`,
                method: "PATCH",
            }, failureHash)).user;
        }),
        /**
         * Used to update current user
         */
        requestDelete: (email) => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                body: {
                    email_confirm: email,
                },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/request-delete-user`,
                method: "POST",
            }, failureHash)).user;
        }),
    },
    common: {
        /**
         * Used to change users email
         */
        emailChange: ({ email, password, }) => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                body: Object.assign({ email }, (password && { password })),
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/email-change`,
                method: "POST",
            }, failureHash)).user;
        }),
        /**
         * Used to confirm email
         */
        emailVerify: ({ user_id, token, }) => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                body: { token, user_id },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/email-verify`,
                method: "POST",
            }, failureHash)).user;
        }),
        /**
         * Used to request email confirmations send
         */
        emailVerifyRequest: () => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/email-verify-request`,
                method: "POST",
            }, failureHash)).user;
        }),
        /**
         * Used to login via email and password
         */
        login: (req) => __awaiter(void 0, void 0, void 0, function* () {
            return yield apiRequest({
                body: req.body,
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/login${REACT_APP__RECAPTCHA_TOKEN
                    ? "?nocaptcha_token=" + REACT_APP__RECAPTCHA_TOKEN
                    : ""}`,
                method: "POST",
            }, failureHash).then((resp) => {
                window.epUserId = resp.user.id;
                return resp;
            });
        }),
        /**
         * Used to confirm auth if 2FA is enabled for user
         */
        loginConfirm: ({ token, user_id, }) => __awaiter(void 0, void 0, void 0, function* () {
            return yield apiRequest({
                body: {
                    token,
                    user_id,
                },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/login-confirm`,
                method: "POST",
            }, failureHash);
        }),
        /**
         * Used to enable/disable 2FA for user
         */
        loginConfirmEnable: ({ enabled, }) => __awaiter(void 0, void 0, void 0, function* () {
            return yield apiRequest({
                body: { enabled },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/login-confirm-enable`,
                method: "POST",
            }, failureHash);
        }),
        /**
         * Used to confirm enable/disable 2FA for user
         */
        loginConfirmEnableConfirm: ({ token, user_id, }) => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                body: { token, user_id },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/login-confirm-enable-confirm`,
                method: "POST",
            }, failureHash);
        }),
        /**
         * Used to logout current user
         */
        logout: () => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/logout`,
                method: "POST",
            }, failureHash).then((resp) => {
                window.epUserId = undefined;
                return resp;
            });
        }),
        /**
         * Used to change current user's password
         */
        passwordChange: ({ password, password_new, }) => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                body: Object.assign({ password_new }, (password && { password })),
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/password-change`,
                method: "POST",
            }, failureHash);
        }),
        /**
         * Used to reset current user's password
         */
        passwordReset: ({ password, token, user_id, }) => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                body: {
                    password,
                    token,
                    user_id,
                },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/password-reset`,
                method: "POST",
            }, failureHash);
        }),
        /**
         * Used to request confirmation code for password reset
         */
        passwordResetRequest: ({ email, recaptcha, }) => __awaiter(void 0, void 0, void 0, function* () {
            return (yield apiRequest({
                body: { email, recaptcha },
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/password-reset-request${REACT_APP__RECAPTCHA_TOKEN
                    ? "?nocaptcha_token=" + REACT_APP__RECAPTCHA_TOKEN
                    : ""}`,
                method: "POST",
            }, failureHash)).user;
        }),
        /**
         * Used to create new user
         */
        signUp: (req) => __awaiter(void 0, void 0, void 0, function* () {
            return apiRequest({
                body: req.body,
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/users/signup${REACT_APP__RECAPTCHA_TOKEN
                    ? "?nocaptcha_token=" + REACT_APP__RECAPTCHA_TOKEN
                    : ""}`,
                method: "POST",
                query: req.query,
            }, failureHash).then((resp) => {
                window.epUserId = resp.user.id;
                return resp;
            });
        }),
    },
};
//# sourceMappingURL=user.js.map